import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../ui_kit/button/Button';
import googleAnalytics from '../../../services/google_analytics';
import facebookPixel from '../../../services/facebook_pixel';
import retentionPixel from '../../../services/retention_pixel';

function Preorder(props) {
  const trackAddToBag = () => {
    const {
      productId, price, variant, name, sku, productUrl, image,
    } = props;

    const product = {
      sku, variant, name, price,
    };

    facebookPixel.trackAddToBag(productId, price);
    googleAnalytics.trackAddToBag(product);
    retentionPixel.trackAddToBag({
      productId, price, name, url: window.location.origin + productUrl, imageUrl: image,
    });
  };

  const addToBag = () => {
    const { addToBagClickHandler } = props;

    trackAddToBag();

    addToBagClickHandler();
  };

  const {
    buttonColor, loading, className, text,
  } = props;

  return (
    <Button
      text={text}
      size="small"
      color={buttonColor}
      className={className}
      loading={loading}
      onClickHandler={addToBag}
    />
  );
}

Preorder.propTypes = {
  price: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  productUrl: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  buttonColor: PropTypes.oneOf([
    'black', 'white', 'blue', 'transparent-blue', 'yellow', 'green', 'transparent-green',
  ]),
  addToBagClickHandler: PropTypes.func.isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.string,
};

Preorder.defaultProps = {
  variant: null,
  buttonColor: 'blue',
  loading: false,
  className: null,
  text: 'PRE-ORDER',
  image: PropTypes.string.isRequired,
};

export default Preorder;
